import classNames from 'classnames';

const FieldError = ({ message }: { message?: string }) => (
  <p
    className={classNames('mb-2 mt-sh-5 text-sh-xs text-field-error', {
      visible: !!message,
      invisible: !message,
    })}>
    {message}
  </p>
);

export default FieldError;
